import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

type Context = 'gallery';

const MAX_TAGS = 8;

interface Props {
  context: Context;
  onChange: (tags: string[]) => void;
  selectedTags: string[];
}

const HashtagSelector: React.FC<Props> = ({ onChange, selectedTags }) => {
  const { t } = useTranslation();
  const [inputTag, setInputTag] = useState('');

  const isFull = selectedTags.length >= MAX_TAGS;

  const handleAddTag = (tag: string) => {
    const raw = tag.trim();
    if (!raw) return;

    const cleaned = raw.startsWith('#') ? raw : `#${raw}`;

    if (selectedTags.includes(cleaned)) {
      setInputTag('');
      return;
    }

    if (isFull) {
      setInputTag('');
      return;
    }

    onChange([...selectedTags, cleaned]);
    setInputTag('');
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (inputTag.trim()) {
        handleAddTag(inputTag);
      }
    }
  };

  const handleRemoveTag = (tag: string) => {
    onChange(selectedTags.filter((t) => t !== tag));
  };

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: 6,
        marginBottom: 8,
      }}
    >
      {/* Input */}
      <input
        type="text"
        value={inputTag}
        placeholder={t('hashtagSelector.placeholdermobile', 'Add hashtags')}
        onChange={(e) => setInputTag(e.target.value)}
        onKeyDown={handleKeyDown}
        disabled={isFull}
        style={{
          padding: '4px 6px',
          width: '90%',
          borderRadius: '14px',
          border: '1px solid #4b5563',
          backgroundColor: 'rgba(15,23,42,0.9)',
          color: '#e5e7eb',
          fontSize: 16, // ✅ prevents mobile zoom
          outline: 'none',
        }}
      />

      {/* Counter */}
      {selectedTags.length > 0 && (
        <div style={{ fontSize: 11, color: '#9ca3af' }}>
          {selectedTags.length} / {MAX_TAGS}
        </div>
      )}

      {/* Selected Tags */}
      {selectedTags.length > 0 && (
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 6,
          }}
        >
          {selectedTags.map((tag) => (
            <span
              key={tag}
              onClick={() => handleRemoveTag(tag)}
              style={{
                backgroundColor: 'rgba(15,23,42,1)',
                color: '#e5e7eb',
                padding: '4px 8px',
                borderRadius: '12px',
                cursor: 'pointer',
                userSelect: 'none',
                border: '1px solid rgba(148,163,184,0.5)',
                fontSize: 12,
              }}
            >
              {tag} ✕
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default HashtagSelector;
